import { select } from 'redux-saga/effects';
import { currentLocationSelector } from '../../common/selectors';
import { HEALTHBOARD } from '../../../constants/routes';

export function* isHealthBoardPage() {
  const location = yield select(currentLocationSelector);

  return location.includes(HEALTHBOARD);
}



// WEBPACK FOOTER //
// ./src/redux/chatConnection/helpers/isHealthboardSaga.js